import {useTownhallTemplate} from 'Event/template/Townhall'
import styled from 'styled-components'
import React from 'react'
import {useGuestVariables} from 'Event'
import Configurable from 'organization/Event/Configurable'
import TitleConfig from 'Event/template/Townhall/Login/Title/TitleConfig'

export default function Title() {
  const {
    login: {
      welcome: {text},
    },
  } = useTownhallTemplate()
  const v = useGuestVariables()

  return (
    <Configurable>
      <TitleConfig />
      <TitleBase aria-label="event login title">{v(text)}</TitleBase>
    </Configurable>
  )
}

export function TitleBase(props: {
  children: string | JSX.Element
  'aria-label'?: string
  className?: string
}) {
  const {
    login: {
      welcome: {color, fontSize},
    },
    textColor,
  } = useTownhallTemplate()

  if (!props.children) {
    return null
  }

  return (
    <TitleText
      titleColor={color}
      textColor={textColor}
      fontSize={fontSize}
      aria-label={props['aria-label']}
      className={props.className}
    >
      {props.children}
    </TitleText>
  )
}

export const TitleText = styled.div<{
  titleColor?: string | null
  textColor: string
  fontSize: number
}>`
  color: ${(props) => (props.titleColor ? props.titleColor : props.textColor)};
  font-size: ${(props) => props.fontSize}px;
  font-weight: 500;
  margin-bottom: ${(props) => props.theme.spacing[4]};
  text-align: center;
`
